import { Col, Typography } from "antd";

import MLSBanner from "assets/Images/MLSBanner.png";
const Banner = () => {
  const { Text } = Typography;
  return (
    <>
      <div
        style={{
          backgroundImage: `url('${MLSBanner}')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="!p-4 !rounded-lg !w-full !h-[150px] md:!h-[200px] xl:!h-[300px] !flex items-center justify-center  "
      >
        <div className="!grid gap-2" >

        <Col xs={24} className="!flex justify-center">
          <Text className="!text-2xl md:!text-4xl xl:!text-6xl !text-black !font-bold">
          sariilanlar.com
          </Text>
        </Col>
        <Col xs={24} className="!flex justify-center">
          <Text className="md:!text-xl !text-lg !text-black ">
            {" "}
            PPS Portalına Hoş Geldiniz.
          </Text>
        </Col>
        </div>
      </div>
    </>
  );
};

export default Banner;
